$(document).ready(function(){
    $('.organo-republic-product-variations-slider__items').slick({
        infinite: false,
        slidesToShow: 3.5,
        slidesToScroll: 1,
        variableWidth: false,
        arrows: false,
        dots: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3.5,
                    slidesToScroll: 1,
                    infinite: false,
                    variableWidth: false,
                    arrows: false,
                    dots: false
                }
            },
            {
                breakpoint: 9999,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: false,
                    variableWidth: false,
                    arrows: true,
                    prevArrow: '.organo-republic-product-variations-slider__nav-button--prev',
                    nextArrow: '.organo-republic-product-variations-slider__nav-button--next',
                    dots: false
                }
            }
        ]
    });
});